import { render } from "./WpeNumber.vue?vue&type=template&id=28438afb"
import script from "./WpeNumber.vue?vue&type=script&lang=js"
export * from "./WpeNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeNumber.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28438afb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28438afb', __exports__)) {
    api.reload('28438afb', __exports__)
  }
  
  module.hot.accept("./WpeNumber.vue?vue&type=template&id=28438afb", () => {
    api.rerender('28438afb', render)
  })

}


export default __exports__